import { PageHeader } from '../../components/shared';
import { AiConversation } from '../../components/AiPanel/AiConversation';
import { AiComposer } from '../../components/AiPanel/AiComposer';
import { AiChatHead } from './AiChatHead';
import { useAiChatStore } from '../../store/aiChatStore';
import './AiShell.css';

/**
 * AI · 대화 — AI 메뉴의 첫 화면 (설계 판 A 자리 · 판 B 배선 · 정의서 M1·M3·M6).
 *
 * ★★ **제목은 레일 메뉴 이름과 같다**(정본 A3). 좌측에서 「대화」를 눌렀는데 화면이 「AI 챗」이면
 *    같은 곳인지 알 수 없다 — 어긋난 곳이 열한 군데 있었고 붙잡는 검사가 0이었다.
 *
 * ★★★ **패널과 같은 부품을 쓴다**(M6) — 폭만 400 → 760 이다. 두 벌로 만들면 한쪽만
 *    고쳐지는 날이 온다. 대화 내용도 한 곳(`aiChatStore`)이라 **패널에서 묻다가 전체로
 *    넘어와도 이어진다.**
 *
 * ★ 본문은 760 가운데 한 칸이다(M3) — 두 대조군(ChatGPT · Claude) 다 그렇다. CSS 는 `AiShell.css`.
 *
 * ★★★ **새 대화는 «가운데»에 선다**(2026-09-10 사용자 지적: 「너무 위에 있다」).
 *    빈 화면에서 인사말과 입력칸이 위에 붙어 있으면 아래가 통째로 비어 「덜 그려진 화면」으로
 *    보인다. 말이 하나라도 붙으면 **평소 배치로 내려간다** — 로그가 자라고 입력칸은 바닥에.
 *    두 대조군이 다 그렇게 한다.
 */
export function AiChatPage() {
  const empty = useAiChatStore((s) => s.messages.length === 0);
  return (
    <div className="aichat">
      <PageHeader
        breadcrumb={['AI', '대화']}
        title="대화"
        description="AI 에게 묻고 답을 받는 자리입니다."
      />
      <div className={`aichat__col${empty ? ' aichat__col--empty' : ''}`}>
        <div className="aichat__log">
          {/* ★ 지금 읽는 대화가 무엇인지 본문이 말한다 — 화면 제목(「대화」)은 안 건드린다(정본 A3). */}
          <AiChatHead />
          <AiConversation
            emptyHint={<p>캘린더 · 근태 · 회의록은 지금 바로 물어볼 수 있습니다.</p>}
          />
        </div>
        <AiComposer />
      </div>
    </div>
  );
}
